class Effect {
    __mechanic;
    __mods;
    constructor(mechanic) {
        this.__mechanic = mechanic;
        this.__mods = [];
    }
    get mechanic() {
        return this.__mechanic;
    }
    withMod(mod) {
        this.__mods.push(mod);
        return this;
    }
    removeModOfType(mod, index) {
        for (let i = 0; i < this.__mods.length; i++) {
            if (this.__mods[i] instanceof mod && this.__mods[i].index === index) {
                this.__mods.splice(i, 1);
                return;
            }
        }
    }
    applyMods(amount) {
        for (let i = 0; i < this.__mods.length; i++) {
            amount = this.__mods[i].apply(amount);
        }
        return amount;
    }
}
export default Effect;
